/* src/app/FW/controls/timepicker-entry/timepicker-component/timepicker.component.scss */
.time-picker-button {
  padding: 0;
  margin: 0;
  min-width: 44px;
}
/*# sourceMappingURL=timepicker.component.css.map */
